import { render, staticRenderFns } from "./BeginnerIconOnboarding.vue?vue&type=template&id=60cfe9a8"
import script from "./BeginnerIconOnboarding.vue?vue&type=script&setup=true&lang=ts"
export * from "./BeginnerIconOnboarding.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports